module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/pc/hospital_detail/img_online_module-5f6cd92b29406dfde95fae02815129ba.png";